export const ACTIVE_PAGE_TAB_LEGACY = 'activePageTabLegacy';
export const ACTIVE_PAGE_TAB = 'activePageTab';

export const clearPageTabsStateLegacy = () => {
    sessionStorage.removeItem(ACTIVE_PAGE_TAB_LEGACY);
};

export const getSessionStorageActivePageTabLegacy = () => {
    return Number(sessionStorage?.getItem(ACTIVE_PAGE_TAB_LEGACY));
};

export const setSessionStorageActivePageTabLegacy = (tab: number) => {
    sessionStorage.setItem(ACTIVE_PAGE_TAB_LEGACY, tab.toString());
};

export const getSessionStorageActivePageTab = (key: string) => {
    const tabJson = sessionStorage.getItem(ACTIVE_PAGE_TAB);
    if (!tabJson) return 0;

    const tabs = JSON.parse(tabJson) as Record<string, number>;
    if (tabs && tabs[key] != null) return tabs[key];

    return 0;
};

export const setSessionStorageActivePageTab = (key: string, num: number) => {
    const tabJson = sessionStorage.getItem(ACTIVE_PAGE_TAB);
    let tabs: Record<string, number> = {};
    if (tabJson != null) tabs = JSON.parse(tabJson) as Record<string, number>;

    tabs[key] = num;
    sessionStorage.setItem(ACTIVE_PAGE_TAB, JSON.stringify(tabs));
};

export const clearPageTabsState = (key: string) => {
    const tabJson = sessionStorage.getItem(ACTIVE_PAGE_TAB);
    let tabs: Record<string, number> = {};
    if (tabJson != null) tabs = JSON.parse(tabJson) as Record<string, number>;
    delete tabs[key];

    sessionStorage.setItem(ACTIVE_PAGE_TAB, JSON.stringify(tabs));
};
